// removed by extract-text-webpack-plugin
module.exports = {"products":"Products-module__products___2qNL7","title":"Products-module__title___2vswn","product-rows":"Products-module__product-rows___3Y65Z","mobile":"Products-module__mobile___2Srdz"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Products/Products.module.scss
// module id = 329
// module chunks = 0 1